function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useRTL } from "../../../hooks/useRTL";
import { cn } from "../../../lib/utils";
import Wave from "../../../lib/wave";
import * as RadioGroup from '@radix-ui/react-radio-group';
import { useCallback, useEffect, useState } from 'react';
import { styles as radixStyle, sizeStyle } from "../../style/radio";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RADIO_THEME = /*#__PURE__*/function (RADIO_THEME) {
  RADIO_THEME["LIGHT"] = "light";
  RADIO_THEME["DARK"] = "dark";
  return RADIO_THEME;
}({});

// RadioItem props

// Radio props

var Radio = function Radio(props) {
  var _ref = props !== null && props !== void 0 ? props : {},
    className = _ref.className,
    defaultValue = _ref.defaultValue,
    _ref$disabledAll = _ref.disabledAll,
    disabledAll = _ref$disabledAll === void 0 ? false : _ref$disabledAll,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    value = _ref.value,
    radioName = _ref.radioName,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    handleRadioChange = _ref.handleRadioChange,
    orientation = _ref.orientation;
  var _useState = useState(defaultValue || value),
    _useState2 = _slicedToArray(_useState, 2),
    checkedValue = _useState2[0],
    setCheckedValue = _useState2[1];
  var isRTL = useRTL();
  var handleChange = useCallback(function (cv) {
    if (cv !== checkedValue) {
      setCheckedValue(cv);
      if (typeof handleRadioChange === 'function') {
        var _item = items.find(function (_ref2) {
          var value = _ref2.value;
          return value === cv;
        });
        if (_item) handleRadioChange(cv, _item);
      }
    }
  }, [checkedValue, handleRadioChange, items]);
  useEffect(function () {
    setCheckedValue(value);
  }, [value]);
  useEffect(function () {
    // const localTheme = window?.localStorage?.getItem(
    //   'dumi:prefers-color',
    // ) as RadioThemeType;
    // if (localTheme) {
    //   setMolyTheme(localTheme);
    // }
  }, []);
  return items.length ? /*#__PURE__*/_jsx("div", {
    className: cn(radixStyle, className, sizeStyle[size]),
    children: /*#__PURE__*/_jsx(RadioGroup.Root, {
      className: cn('radio-group-root', _defineProperty({}, orientation, !!orientation)),
      defaultValue: defaultValue,
      value: checkedValue,
      "aria-label": radioName,
      dir: isRTL ? 'rtl' : 'ltr',
      name: radioName,
      onValueChange: handleChange,
      children: items.map(function (radio) {
        return /*#__PURE__*/_jsxs("div", {
          "data-checked": checkedValue === radio.value,
          className: cn('radio-group-item__wrap', {
            disabled: disabledAll || radio.disabled
          }),
          children: [/*#__PURE__*/_jsx(Wave, {
            component: "Radio",
            children: /*#__PURE__*/_jsx(RadioGroup.Item, {
              className: "radio-group-item",
              value: radio.value,
              id: "".concat(radioName || '').concat(radio.key),
              disabled: disabledAll || radio.disabled,
              children: /*#__PURE__*/_jsx(RadioGroup.Indicator, {
                className: "radio-group-indicator"
              })
            })
          }), /*#__PURE__*/_jsx("label", {
            className: "radio-group-item__label",
            htmlFor: "".concat(radioName || '').concat(radio.key),
            children: radio === null || radio === void 0 ? void 0 : radio.childrenNode
          })]
        }, radio.key);
      })
    })
  }) : null;

  // return <Wave component="radio">{radioNode}</Wave>;
};
export { Radio };